import {RouteRecordRaw} from "vue-router";
import NotificationsIndex from '../pages/Index.vue';

export const routes: RouteRecordRaw[] = [
  {
    path: '/notifications',
    name: 'notifications.index',
    component: NotificationsIndex,
  },
];
